// extracted by mini-css-extract-plugin
export default {"exercise_btn":"ButtonNew_exercise_btn__usduy"};